import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import PortfolioMain from './PortfolioMain';
import Footer from '../../components/Footer';

const Portfolio = () => {
  return (
    <>
      <HeaderSeven />

      <PortfolioMain />

      <Footer />
    </>
  );
};

export default Portfolio;
